import { RouteObject } from 'react-router-dom'
import { PageLayout } from '$components/common'
import { default as Menus } from '.'

const basePath = '/stock'
export const menusRoutes: RouteObject[] = [
  {
    path: `${basePath}/all-menus`,
    element: (
      <PageLayout title="Menus" displayLeftTitle={false}>
        <Menus.Menus.Component />
      </PageLayout>
    ),
    loader: Menus.Menus.Loader,
  },
  {
    path: `${basePath}/all-menus/create`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Menus.CreateMenu.Component />
      </PageLayout>
    ),
    loader: Menus.CreateMenu.Loader,
  },
  {
    path: `${basePath}/all-menus/:menuId`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Menus.ViewMenu.Component />
      </PageLayout>
    ),
    loader: Menus.ViewMenu.Loader,
  },
]
